import React from 'react';
import { Outlet } from 'react-router-dom';
import AppBarComponent from '../components/appbar';
import FooterBar from '../components/FooterBar';
import ChatSplit from '../components/AgentChat/ChatSplit';

/**
 * AppLayout - Shared layout for standard pages (Home, Search, Debug, etc.)
 * Uses React Router's Outlet pattern for nested routes.
 * 
 * This layout provides:
 * - Consistent AppBar at the top
 * - Main content area that renders child routes via Outlet
 * - FooterBar at the bottom (fixed position) - reads all state from Redux directly
 */
const AppLayout = () => {
    return (
        <ChatSplit>
            <AppBarComponent />
            <main className="flex-1 flex flex-col overflow-hidden min-h-0">
                <Outlet />
            </main>
            <FooterBar />
        </ChatSplit>
    );
};

export default AppLayout;

